import { React, useState, useContext, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { UserContext } from "../../context/userContext/userContext";
import { useStyle } from "../../context/styleContext/styleContext";
import { ShoppingCartContext } from "../../context/shoppingCartContext/shoppingCartContext";
import { toast } from "react-hot-toast";
import ReactGA from "react-ga4";
import SubscribeRedirectModal from "../../components/SubscribeRedirectModal/SubscribeRedirectModal";
import LoginSubscribePromptModal from "../../components/LoginSubscribePromptModal/LoginSubscribePromptModal";
import LeaveReviewModal from "./leaveReviewModal";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import ProductSchemaMarkup from "./ProductSchemaMarkup";
import {
  Box,
  Typography,
  Button,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  useMediaQuery,
  Rating,
  Divider,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useTheme } from "@mui/material/styles";
import LoginRegisterModal from "./LoginRegisterModal";


export default function ProductPage(props) {
  const { user } = useContext(UserContext);
  const { style } = useStyle();
  const { addToCart } = useContext(ShoppingCartContext);

  const [productData, setProductData] = useState();
  const [forwardToSubscribePage, setForwardToSubscribePage] = useState(false);
  const [windowsDownloadRequested, setWindowsDownloadRequested] = useState(false);
  const [macDownloadRequested, setMacDownloadRequested] = useState(false);
  const [bulletPointData, setBulletPointData] = useState();
  const isMobile = useMediaQuery("(max-width: 768px)");

  const [isLoginRegisterModalOpen, setLoginRegisterModalOpen] = useState(false);
  const [isSubscriptionLoginRegisterModalOpen, setSubscriptionLoginRegisterModalOpen] = useState(false);
  const [isLeaveReviewModalOpen, setLeaveReviewModalOpen] = useState(false);

  const name = window.location.pathname.split("/").pop();

  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: name, title: name });
    getProductPageInfo();
  }, []);

  const closeModal = setModalFn => () => setModalFn(false);
  const closeSubscribeModal = setModalFn => () => setModalFn(false);
  const [height, setHeight] = useState(window.innerHeight)
  useEffect(() => {
    function handleResize() {      
      setHeight(window.innerHeight)
  }  
    window.addEventListener('resize', handleResize)
  })


  const downloadWindowsVST = async () => {
    
    const token = localStorage.getItem('token')
    const productSKU = productData.SKU;
    const productVersion = productData.productVersion;
    setWindowsDownloadRequested(true);
      
      if(user)
      {
        console.log("windows click..")

        try{


        const data = await axios.post('/api/register_free_product', { token:token, sku:productSKU, productVersion:productVersion });

        if(!data)
        {
          toast.error("Error: your request could not be completed at this time.")
          return
        }
        
        }catch(error){
          toast.error("Error: your request could not be completed at this time.")
          return
        }

        var downloadLocation = productData.windowsDownloadURI;
        window.location.href = downloadLocation;   

      }
      else
      {
        setLoginRegisterModalOpen(true)
      }

  }



  const navToSubscribePage = async () => {
    console.log("nav to subscribe")
  if(user)
  {
    const userEmail = user.email;
    window.location.href = `https://buy.stripe.com/6oE3gfaAxdanaticMM?prefilled_email=${encodeURIComponent(userEmail)}`

  }
  else
  {
    setForwardToSubscribePage(true)
    setLoginRegisterModalOpen(true)
  }

  }

  const downloadMacVST = async () => {
    const token = localStorage.getItem('token')
    const productSKU = productData.SKU;
    const productVersion = productData.productVersion;
    setMacDownloadRequested(true);
      
      if(user)
      {
        console.log("mac click..")

        try{


        const data = await axios.post('/api/register_free_product', { token:token, sku:productSKU, productVersion:productVersion });

        if(!data)
        {
          toast.error("Error: your request could not be completed at this time.")
          return
        }
        
        }catch(error){
          toast.error("Error: your request could not be completed at this time.")
          return
        }

        var downloadLocation = productData.macDownloadURI;
        window.location.href = downloadLocation;   

      }
      else
      {
        setLoginRegisterModalOpen(true)
      }
  }

  const loginCallback = async (userEmail) => {

    console.log("Login process complete!")
    const token = localStorage.getItem('token')
    if(!token)
    {
      return
    }
    setLoginRegisterModalOpen(false);
    console.log("User email? ")
    console.log(userEmail);
    
    
    if(forwardToSubscribePage)
    {
      setForwardToSubscribePage(false)
      if(userEmail){
        window.location.href = `https://buy.stripe.com/6oE3gfaAxdanaticMM?prefilled_email=${encodeURIComponent(userEmail)}`
      }
    }
    if(windowsDownloadRequested)
    {
      setWindowsDownloadRequested(false);
      // var downloadLocation = productData.windowsDownloadURI;
      // window.location.href = downloadLocation;
      try{
        const data = await axios.post('/api/register_free_product', { token:token, sku:productData.SKU, productVersion:productData.productVersion });

        if(!data)
        {
          toast.error("Error: your request could not be completed at this time.")
          return
        }
        
        }catch(error){
          toast.error("Error: your request could not be completed at this time.")
          return
        }

        var downloadLocation = productData.windowsDownloadURI;
        window.location.href = downloadLocation;  

    }
    if(macDownloadRequested)
    {
      setMacDownloadRequested(false);
      // var downloadLocation = productData.macDownloadURI;
      // window.location.href = downloadLocation;
      try{
        const data = await axios.post('/api/register_free_product', { token:token, sku:productData.SKU, productVersion:productData.productVersion });

        if(!data)
        {
          toast.error("Error: your request could not be completed at this time.")
          return
        }
        
        }catch(error){
          toast.error("Error: your request could not be completed at this time.")
          return
        }

        var downloadLocation = productData.macDownloadURI;
        window.location.href = downloadLocation;   
    }

  };



  // const subscribeLoginCallback = async () => {
  //   console.log("subscription callback fired!")
  
  //     const token = localStorage.getItem('token')
  //     if(!token)
  //     {
  //       return
  //     }

  //     console.log("user email: ")
  //     if(user)
  //     {
  //       console.log("USER SUCCESSFULLY LOADED")
  //       console.log(user.email)
  //     }


  
  //     // const res = await axios.post("/api/mark_review", {
  //     //   token,
  //     //   reviewId:storedReviewId,
  //     //   type:storedVote,
  //     // });
      
  //     setSubscriptionLoginRegisterModalOpen(false);
  //     //window.location.href = `https://buy.stripe.com/6oE3gfaAxdanaticMM?prefilled_email=${encodeURIComponent(user.email)}`
  //     console.log("FINISHED!!")
  //   };


  const getProductPageInfo = async () => {
    try {
      const { data } = await axios.post("/get_product_page_info", { productURI: name });
      if (data) {
        setProductData(data);
        setBulletPointData([
          data.bulletPoint1,
          data.bulletPoint2,
          data.bulletPoint3,
          data.bulletPoint4,
          data.bulletPoint5,
        ].filter(Boolean));
        document.title = `Parish Audio | Cutting-Edge Audio Processing | ${data.name}`;

      }
    } catch {
      console.log("Error retrieving data...");
    }
  };

  const addProductToCart = (e) => {
    e.preventDefault();
    addToCart(productData.SKU);
  };


  
  return (
    <>
      {!productData && (<><div style={{minHeight:height - 130}}><LoadingSpinner /></div></>)}
      {productData && (
        <Box sx={{ width: "95%", margin: "auto", minHeight: "calc(100vh - 160px)" }}>
          <Box
            sx={{
              maxWidth: "900px",
              margin: "auto",
              p: isMobile ? 1 : 2,
              mt: 2,
              mb: 4,
              backgroundColor: style.color1,
              borderRadius: 2,
              color: style.color4,
              boxShadow: 10,
            }}
          >

{ isMobile && (
            <>
             <Box
              sx={{
                display: "flex",
                flexDirection: isMobile ? "column" : "row",
                alignItems: isMobile ? "center" : "flex-start",
                gap: 1,
                mb: 3,
                width:'90%',
                margin:'auto',
                backgroundColor:style.color1, 
                filter:'brightness(1.2)',
                p:2,
                boxShadow:10,
                borderRadius:'5px'
              }}
            >
               <Typography variant="h1" sx={{ fontSize: "2rem", mb: 0.5, fontWeight: "bold", mt:0 }}>

               {productData.name}
               </Typography>

               <Box sx={{ textAlign: "center",p:2, backgroundColor:'rgba(0,0,0,0.3)', borderRadius:'4px', boxShadow:10}}>
                <img
                  src={productData.images[2]?.URI}
                  alt={productData.images[2]?.altText}
                  style={{
                    width:'95%',
                    borderRadius: 0,
                    objectFit: "contain",
                  }}
                />
              </Box>
              <Typography variant="body1" sx={{ mb: .5 }}>{productData.shortDescription}</Typography>

              {productData.audioURIs?.length > 0 && (
                        <><h2 style={{fontSize:"1.0rem", marginBottom:'5px', marginTop:'10px', textAlign:'left', width:'100%'}}>Demo</h2>
                        <div style={{width:'100%', flex:1, marginBottom:'20px'}}>
                
                        
                          <audio controls style={{height:'30px', width:'100%', flex:1 }}>
                          <source src={productData.audioURIs[0]} type="audio/mpeg" />
                          Your browser does not support the audio element.
                        </audio>
                          </div>
                      </>
                      )}



              <div style={{display:'flex', flexDirection:'column', width:'100%'}}>
                  <div style={{display:'flex', flexDirection:'row', textAlign:'left', width:'100%', }}>
                    <a href={'/reviews/' + productData.productURI}>
                    <Rating value={productData.starRating} precision={0.5} readOnly />
                    </a>
                    <a href={'/reviews/' + productData.productURI}>
                    <Typography sx={{ ml: 1 }}>{productData.ratingCount > 0 && (productData.starRating)}</Typography>
                    </a>
                    <a href={'/reviews/' + productData.productURI}>
                    <Typography sx={{ ml: 3 }}> ({productData.ratingCount} {productData.ratingCount == 1 && (<>review</> )} {productData.ratingCount != 1 && (<>reviews</> )})</Typography>
                    </a>
                  </div>

                  {productData.price > 0 ? (
                    <>
                    <Typography
                        variant="body2"
                        sx={{ color: style.color3, ml:2,textDecoration: "line-through", fontSize: "1.4rem", textAlign:'left' }}
                      >
                        ${productData.msrp.toFixed(2)}
                      </Typography>
                      <Typography variant="h6" sx={{ml:2, mb:2, color: style.color4, fontSize:'1.8rem', textAlign:'left' }}>
                        <strong>${(productData.price).toFixed(2)}</strong>
                      </Typography>
                      
                      <Button
                        onClick={addProductToCart}
                        sx={{
                          mt: 1,
                          backgroundColor: style.color1,
                          color: style.color4,
                          border: `1px solid ${style.color2}`,
                          minWidth:'125px',
                          width:'95%',
                          margin:'auto',
                          mt:2,
                          filter:'brightness(1.05)',
                          boxShadow:10,
                          mt:2,
                          "&:hover": { filter:'brightness(1.2)'},
                        }}
                      >
                        Add to Cart
                      </Button>
                    </>
                  ) : (
                    <>
                    </>
                  )}

              </div>
                
                <Divider style={{backgroundColor:style.color2, width:'100%'}} sx={{mt:2}} />

                {productData.price <= 0 && ( 
                        <>
                        
                        <div style={{ color: style.color2, padding:'0px', fontWeight: "bold", fontSize: "3.5rem", color:'rgb(30,150,0)', textAlign:'center', marginBottom:'0px'}}>
                         FREE
                        </div>
                          <h2 style={{textAlign:'center', marginTop:'0px', marginBottom:'10px'}}>Download VST3 Plugin</h2>
                          <div style={{ textAlign:'center'}}>
                              {productData.windowsDownloadURI && (
                                <Button onClick={downloadWindowsVST} sx={{ mt: 1, pt:2, boxShadow:10, margin:'auto', backgroundColor:style.color1, transition: 'filter 0.3s ease',  '&:hover': { filter: 'brightness(1.2)' } }}>
                                  <div style={{display:'flex', flexDirection:'column'}}>
                                    <div style={{backgroundColor:'black', padding:'4px', paddingLeft:'8px', paddingRight:'8px', paddingTop:'8px'}}>
                                      <img src='/windows_logo.png' style={{maxWidth:'80px', maxHeight:'80px', margin:'auto'}} />
                                    </div>
                                    <div style={{textAlign:'center'}}>
                                      <strong>Windows</strong>
                                    </div>
                                  </div>
              
                                </Button>
                              )}
                              {productData.macDownloadURI && (
                                <Button onClick={downloadMacVST} sx={{ mt: 1, pt:2, boxShadow:10, margin:'auto', ml:2, backgroundColor:style.color1, transition: 'filter 0.3s ease',  '&:hover': { filter: 'brightness(1.2)' } }}>
                                <div style={{display:'flex', flexDirection:'column'}}>
                                  <div style={{backgroundColor:style.color4, padding:'4px', paddingLeft:'8px', paddingRight:'8px', paddingTop:'8px'}}>
                                    <img src='/apple_logo.svg' style={{maxWidth:'80px', maxHeight:'80px', margin:'auto'}} />
                                  </div>
                                  <div style={{textAlign:'center'}}>
                                    <strong>Mac</strong>
                                  </div>
                                </div>
            
                              </Button>
                              )}
                          </div></>  )}


                          {productData.price > 0 && ( 
                        <>
                        
              
                          <Box
                            sx={{
                             
                              color: 'white',
                              borderRadius: 1,
                              boxShadow: 10,
                              padding: 1,
                              flex:1,
                              display: 'flex',
                              flexDirection: 'column',
                              justifyContent: 'space-between',
                              textAlign: 'center',
                              mt: 0,
                              mb:1,
                            }}
                          >
                            <Typography sx={{ fontSize:'2rem', fontWeight: 'bold', mt:0 }}>
                              7 Day Free Trial
                            </Typography>

                            <Typography variant="body2" sx={{ fontSize: '1rem', lineHeight: 1.5 }}>
                              Get full access to <strong> ALL</strong> plugins, only $9.95 / month
                            </Typography>
                            <Typography variant="body2" sx={{ fontSize: '1rem', lineHeight: 1.5 }}>
                              cancel anytime
                            </Typography>

                            <Button
                              onClick={navToSubscribePage}
                              sx={{
                                mt: 2,
                                mb:1,
                                ml:1,
                                mr:1,
                                fontSize:'1.2em',
                                boxShadow:10,
                                backgroundColor: style.color2, // gold accent
                                color: style.color4,
                                fontWeight: 'bold',
                                borderRadius: '8px',
                                '&:hover': {
                                  filter:'brightness(1.2)',
                                },
                              }}
                            >
                              Start Free Trial
                            </Button>
                          </Box>
                              
                        </>  )}



              </Box>






              </>
)}






            {/**************** Desktop Version ******************/}


            { !isMobile && (
            <>
             <Box
              sx={{
                display: "flex",
                flexDirection: isMobile ? "column" : "row",
                alignItems: isMobile ? "center" : "flex-start",
                gap: 1,
                mb: 3,
                width:'90%',
                margin:'auto',
                backgroundColor:style.color1, 
                filter:'brightness(1.2)',
                p:2,
                boxShadow:10,
                borderRadius:'5px'
              }}
            >



          <Box sx={{ flexGrow: 1, }}>
              <Typography variant="h1" sx={{ fontSize: "2rem", mb: 0.5, fontWeight: "bold", mt:0 }}>
              {productData.name}
                </Typography>
                <Typography variant="body1" sx={{ mb: .5 }}>{productData.shortDescription}</Typography>

                <Box sx={{ display: "flex", alignItems: "center", mb: .5 }}>
                  <a href={'/reviews/' + productData.productURI}>
                  <Rating value={productData.starRating} precision={0.5} readOnly />
                  </a>
                  <a href={'/reviews/' + productData.productURI}>
                  <Typography sx={{ ml: 1 }}>{productData.ratingCount > 0 && (productData.starRating)}</Typography>
                  </a>
                  <a href={'/reviews/' + productData.productURI}>
                  <Typography sx={{ ml: 3 }}> ({productData.ratingCount} {productData.ratingCount == 1 && (<>review</> )} {productData.ratingCount != 1 && (<>reviews</> )})</Typography>
                  </a>
                  
                </Box>

                {/* Price & Purchase Button */}
                <Box sx={{ mb: 2 }}>
                  {productData.price > 0 ? (
                    <>
                    <Typography
                        variant="body2"
                        sx={{ color: style.color3, textDecoration: "line-through", fontSize: "1.4rem" }}
                      >
                        ${productData.msrp.toFixed(2)}
                      </Typography>
                      <Typography variant="h6" sx={{ color: style.color4, fontSize:'1.8rem' }}>
                        <strong>${(productData.price).toFixed(2)}</strong>
                      </Typography>
                      
                      <Button
                        onClick={addProductToCart}
                        sx={{
                          mt: 1,
                          backgroundColor: style.color1,
                          color: style.color4,
                          border: `1px solid ${style.color2}`,
                          minWidth:'125px',
                          filter:'brightness(1.05)',
                          boxShadow:10,
                          "&:hover": { filter:'brightness(1.2)'},
                        }}
                      >
                        Add to Cart
                      </Button>
                    </>
                  ) : (
                    <>
                    </>
                  )}
                                       {productData.audioURIs?.length > 0 && (
                        <Box sx={{ mt: 1 }}>
                          <Typography variant="h6" sx={{ mb: 1, fontSize:'1em' }}>Demo</Typography>
                          <audio controls style={{ width: "95%", maxWidth:'400px', height:'30px' }}>
                            <source src={productData.audioURIs[0]} type="audio/mpeg" />
                            Your browser does not support the audio element.
                          </audio>
                        </Box>
                        
                      )}
                </Box>
                <Divider style={{backgroundColor:style.color2, width:'100%'}} />


                  {/* FREE PRODUCT BOX */}




                      {productData.price <= 0 && ( 
                        <>
                        
                        <div style={{ color: style.color2, padding:'0px', fontWeight: "bold", fontSize: "3.5rem", color:'rgb(30,150,0)', textAlign:'center', marginBottom:'0px'}}>
                         FREE
                        </div>
                          <h2 style={{textAlign:'center', marginTop:'0px', marginBottom:'10px'}}>Download VST3 Plugin</h2>
                          <div style={{ textAlign:'center'}}>
                              {productData.windowsDownloadURI && (
                                <Button onClick={downloadWindowsVST} sx={{ mt: 1, pt:2, boxShadow:10, margin:'auto', backgroundColor:style.color1, transition: 'filter 0.3s ease',  '&:hover': { filter: 'brightness(1.2)' } }}>
                                  <div style={{display:'flex', flexDirection:'column'}}>
                                    <div style={{backgroundColor:'rgba(0,0,0,.3)', padding:'5px', paddingLeft:'10px', paddingRight:'10px', paddingTop:'10px'}}>
                                      <img src='/windows_logo.png' style={{maxWidth:'80px', maxHeight:'80px', margin:'auto'}} />
                                    </div>
                                    <div style={{textAlign:'center'}}>
                                      <strong>Windows</strong>
                                    </div>
                                  </div>
              
                                </Button>
                              )}
                              {productData.macDownloadURI && (
                                <Button onClick={downloadMacVST} sx={{ mt: 1, pt:2, boxShadow:10, margin:'auto', ml:2, backgroundColor:style.color1, transition: 'filter 0.3s ease',  '&:hover': { filter: 'brightness(1.2)' } }}>
                                <div style={{display:'flex', flexDirection:'column'}}>
                                  <div style={{backgroundColor:style.color4, padding:'5px', paddingLeft:'10px', paddingRight:'10px', paddingTop:'10px'}}>
                                    <img src='/apple_logo.svg' style={{maxWidth:'80px', maxHeight:'80px', margin:'auto'}} />
                                  </div>
                                  <div style={{textAlign:'center'}}>
                                    <strong>Mac</strong>
                                  </div>
                                </div>
            
                              </Button>
                              )}
                          </div></>  )}






                          {productData.price > 0 && ( 
                        <>
                        
              
                          <Box
                            sx={{
                             
                              color: 'white',
                              borderRadius: 1,
                              boxShadow: 10,
                              padding: 1,
                              flex:1,
                              display: 'flex',
                              flexDirection: 'column',
                              justifyContent: 'space-between',
                              textAlign: 'center',
                              mt: 0,
                              mb:1,
                            }}
                          >
                            <Typography sx={{ fontSize:'2rem', fontWeight: 'bold', mt:0 }}>
                              7 Day Free Trial
                            </Typography>

                            <Typography variant="body2" sx={{ fontSize: '1rem', lineHeight: 1.5 }}>
                              Get full access to <strong> ALL</strong> plugins, only $9.95 / month
                            </Typography>
                            <Typography variant="body2" sx={{ fontSize: '1rem', lineHeight: 1.5 }}>
                              cancel anytime
                            </Typography>

                            <Button
                              onClick={navToSubscribePage}
                              sx={{
                                mt: 2,
                                mb:1,
                                ml:1,
                                mr:1,
                                fontSize:'1.2em',
                                boxShadow:10,
                                backgroundColor: style.color2, // gold accent
                                color: style.color4,
                                fontWeight: 'bold',
                                borderRadius: '8px',
                                '&:hover': {
                                  filter:'brightness(1.2)',
                                },
                              }}
                            >
                              Start Free Trial
                            </Button>
                          </Box>
                              
                        </>  )}


                        
                            
              </Box>

              <Box sx={{ maxWidth: isMobile ? "100%" : "50%", maxHeight:'400px', textAlign: "center",p:1, backgroundColor:'rgba(0,0,0,.3)', borderRadius:'8px', boxShadow:10}}>
                <img
                  src={productData.images[0]?.URI}
                  alt={productData.images[0]?.altText}
                  style={{
                    maxWidth: "100%",
                    maxHeight: "500px",
                    borderRadius: 12,
                    objectFit: "contain",
                  }}
                />
              </Box>
    
            </Box>
  
  </>

  
)}
 
{/* ************* END MOBILE SECTION ******************* */}








            <Box sx={{ mt: 4 }}>
              <Typography variant="body1" sx={{ fontSize: "1.1rem", color: style.color4, filter: "brightness(1.3)" }}>
                {productData.longDescription}
              </Typography>
            </Box>

            {/* Highlights */}
            {bulletPointData && bulletPointData.length > 0 && (
              <Box sx={{ mt: 4 }}>
              
                <ul className='a' style={{ paddingLeft: 0.5, filter: "brightness(1.3)", fontSize: "1.05rem" }}>
                  {bulletPointData.map((point, idx) => (
                    <li key={idx} style={{ marginBottom: 10 }}>{point}</li>
                  ))}
                </ul>
              </Box>
            )}

            {/* Controls */}
            {productData.controls?.length > 0 && (
              <Box sx={{ mt: 4 }}>
                <Typography variant="h6" gutterBottom>Controls</Typography>
                {productData.controls.map((control, index) => (
                  <Accordion
                    key={index}
                    sx={{
                      boxShadow: 10,
                      backgroundColor: style.color1,
                      color: style.color4,
                      mb: 2,
                      borderRadius: 1,
                      "&:before": { display: "none" },
                    }}
                  >
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon sx={{ color: style.color2 }} />}
                      sx={{
                        fontWeight: "bold",
                        backgroundColor: style.color1,
                        filter: "brightness(1.2)",
                        borderRadius: 1,
                        "& .MuiAccordionSummary-content": { margin: 0 },
                      }}
                    >
                      {control.name}
                    </AccordionSummary>
                    <AccordionDetails
                      sx={{
                        backgroundColor: style.color1,
                        filter: "brightness(1.35)",
                        fontSize: "1rem",
                        color: style.color4,
                      }}
                    >
                      {control.description}
                    </AccordionDetails>
                  </Accordion>
                ))}
              </Box>
            )}
          </Box>
        </Box>
      )}


        <LoginRegisterModal isOpen={isLoginRegisterModalOpen} close={closeModal(setLoginRegisterModalOpen)} loginComplete={loginCallback}/>

    </>
  );
}

